import Head from 'expo-router/head';

import LoyaltyOffers from '@fhs-legacy/frontend/src/pages/loyalty/loyalty-offers';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function RewardsOffersPage() {
  return (
    <>
      <Head>
        <title>Offers - Firehouse Subs</title>
      </Head>
      <LoyaltyOffers />
    </>
  );
}
